import { useEffect, useState } from "react";

/**
 * Détecte la plateforme (mobile ou desktop) côté client.
 * @returns { isMobile: boolean, isDesktop: boolean }
 */
export function usePlatform() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkPlatform = () => {
      if (typeof window !== "undefined") {
        setIsMobile(window.matchMedia("(max-width: 767px)").matches);
      }
    };
    checkPlatform();
    window.addEventListener("resize", checkPlatform);
    return () => window.removeEventListener("resize", checkPlatform);
  }, []);

  return { isMobile };
} 